import {InputNumber, Space} from 'antd'
import React, {LegacyRef, MutableRefObject} from 'react'
import {Transformer} from 'react-konva'
import {TransformerUIProps} from './TransformerUI'
import {useIntl} from 'react-intl'

export function EllipseTransformerUI(props: TransformerUIProps) {
  const intl = useIntl()
  return (
    <div>
      <Space direction="vertical">
        <InputNumber
          style={{width: '100%'}}
          addonBefore={`${intl.formatMessage({id: 'side'})} 1`}
          addonAfter={intl.formatMessage({id: 'm'})}
          onChange={(value) => {
            props.onChange({
              ...props.element,
              props: {...props.element.props, radiusX: value * 50},
            })
          }}
          value={props.element.props.radiusX / 50}
        />
        <InputNumber
          style={{width: '100%'}}
          addonBefore={`${intl.formatMessage({id: 'side'})} 2`}
          addonAfter={intl.formatMessage({id: 'm'})}
          onChange={(value) => {
            props.onChange({
              ...props.element,
              props: {...props.element.props, radiusY: value * 50},
            })
          }}
          value={props.element.props.radiusY / 50}
        />
      </Space>
    </div>
  )
}
